// Open and Close Accordion-Items
document.body.addEventListener('click', (event) => {
    if (event.target.closest('.accordion--item button')) {
        let item = event.target.closest('.accordion--item');
        let button = item.querySelector('button.accordion--button')
        let container = item.querySelector('.container')
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
            button.setAttribute('aria-expanded', 'true')
            container.removeAttribute('hidden')
            item.querySelectorAll('.container--inner a').forEach(link => {
                link.setAttribute("tabindex", "0");
            });
            
        } else {
            button.setAttribute('aria-expanded', 'false')
            container.setAttribute('hidden', '')
            item.querySelectorAll('.container--inner a').forEach(link => {
                link.setAttribute("tabindex", "-1");
            });
        }

        // Andere Akkordeons schließen
        item.closest('.accordion').querySelectorAll('.accordion--item').forEach(otherItem => {
            if (otherItem !== item) {
                let otherButton = otherItem.querySelector('button.accordion--button')
                let otherContainer = otherItem.querySelector('.container')

                otherItem.classList.remove('active');
                otherButton.setAttribute('aria-expanded', 'false')
                otherContainer.setAttribute('hidden', '')
                otherItem.querySelectorAll('.container--inner a').forEach(link => {
                    link.setAttribute("tabindex", "-1");
                });
            }
        });
    }
});

// BFSG
const accordions = document.querySelectorAll('.accordion');
const accordionItems = document.querySelectorAll('.accordion--item');

accordions.forEach(accordion => {
    const accordionItemButtons = Array.from(accordion.querySelectorAll('.accordion--item button'));

    if (accordionItemButtons.length >= 2) {
        accordion.addEventListener('keydown', (event) => {
            const currentIndex = accordionItemButtons.indexOf(event.target);

            if (currentIndex !== -1) { // Sicherstellen, dass ein gültiger Button fokussiert ist
                if (event.key === 'ArrowDown') {
                    event.preventDefault(); // Standardverhalten verhindern
                    const nextIndex = (currentIndex + 1) % accordionItemButtons.length;
                    accordionItemButtons[nextIndex].focus();
                }

                if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    const prevIndex = (currentIndex - 1 + accordionItemButtons.length) % accordionItemButtons.length;
                    accordionItemButtons[prevIndex].focus();
                }
            }
        });
    }
});

accordionItems.forEach(item => {
    const links = item.querySelectorAll('.container--inner a');
    const firstLink = links[0];
    const lastLink = links[links.length - 1];

    links.forEach(link => {
        link.setAttribute("tabindex", "-1");
    })

    if (links.length > 0) {
        item.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey && document.activeElement === firstLink) {
                    event.preventDefault()
                    item.querySelector('button').focus()
                } else if (!event.shiftKey && document.activeElement === lastLink) {
                    event.preventDefault()
                    item.querySelector('button').focus()
                }
            }
        })
    }
});
